<template>
  <el-dialog :visible.sync="visibleModal" :close-on-click-modal="false" title="批量更新头条账号头像" width="460px" @close="onModalClose">
    <el-dialog :visible.sync="uploadedModal" append-to-body title="上传信息" width="550px">
      <p>成功{{ uploadedInfo.successCnt }}条，失败{{ uploadedInfo.failCnt }}条</p>
      <el-table class="common-el-table-styles" :data="uploadedInfo.failData" border height="220">
        <el-table-column prop="adAccountName" label="账号名称" show-overflow-tooltip width="140"> </el-table-column>
        <el-table-column prop="error" label="失败原因" show-overflow-tooltip> </el-table-column>
      </el-table>
      <span slot="footer">
        <el-button type="primary" @click="uploadedModal = false">我知道了</el-button>
      </span>
    </el-dialog>
    <el-form label-width="90px">
      <el-form-item label="已选账号">{{ adAccountIds.length }}个头条账号</el-form-item>
      <el-form-item label="上传头像">
        <el-upload
          class="avatar-uploader"
          action=""
          :http-request="uploadAvatar"
          :show-file-list="false"
          :before-upload="beforeAvatarUpload"
        >
          <img v-if="imageUrl" :src="imageUrl" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>

        <p class="upload-tips">格式 jpg/jpeg/png/bmp，小于5M，建议尺寸:300*300像素</p>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="onModalClose">取 消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="onUploadConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script setup>
import { ref, computed } from 'vue'
import { Message } from 'view-design'
import { uploadAdvertiserAvatar } from '@/api/ptom.data.model'
// eslint-disable-next-line
const props = defineProps({
  visible: {
    type: Boolean
  },
  adAccountIds: {
    type: Array,
    default: () => []
  }
})
// eslint-disable-next-line
const emits = defineEmits(['update:visible'])

const visibleModal = computed({
  get() {
    return props.visible
  },
  set(v) {
    emits('update:visible', v)
  }
})

const uploadedModal = ref(false)
const uploadedInfo = ref({ successCnt: 0, failCnt: 0, failData: [] })
const imageUrl = ref('')
const formData = ref({})
const submitLoading = ref(false)

const onModalClose = () => {
  visibleModal.value = false
  imageUrl.value = ''
}
const uploadAvatar = ({ file }) => {
  formData.value.file = file
  formData.value.adAccountIdStr = props.adAccountIds.join(',')
}
const onUploadConfirm = () => {
  submitLoading.value = true
  uploadAdvertiserAvatar(formData.value)
    .then((data) => {
      if (data) {
        uploadedModal.value = true
        visibleModal.value = false
        uploadedInfo.value = data
        formData.value = {}
      }
    })
    .finally(() => {
      submitLoading.value = false
    })
}

const beforeAvatarUpload = (file) => {
  const allowTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/bmp']
  const hasValidMime = allowTypes.includes(file.type)
  const hasValidExt = /\.(jpe?g|png|bmp)$/i.test(file.name || '')

  if (!hasValidMime && !hasValidExt) {
    Message.error('仅支持 jpg/jpeg/png/bmp 格式')
    return false
  }

  const isLt5M = file.size / 1024 / 1024 < 5
  if (!isLt5M) {
    Message.error('文件大小需小于 5MB')
    return false
  }

  const objectUrl = URL.createObjectURL(file)
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () => {
      imageUrl.value = objectUrl
      if (!(img.width === 300 && img.height === 300)) {
        Message.warning(`建议尺寸 300x300，当前为 ${img.width}x${img.height}`)
      }
      resolve(true)
    }
    img.onerror = () => {
      // 无法获取尺寸时不阻断上传，但提示
      imageUrl.value = objectUrl
      Message.warning('未能获取图片尺寸，建议使用 300x300')
      resolve(true)
    }
    img.src = objectUrl
  })
}
</script>

<style scoped lang="scss">
::v-deep .avatar-uploader {
  .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 118px;
    height: 118px;
    line-height: 118px;
    text-align: center;
  }

  .avatar {
    width: 118px;
    height: 118px;
    display: block;
  }
}

.upload-tips {
  font-size: 12px;
}
</style>
